import React, { useEffect, useState } from 'react'
import Datepicker from '../ui/datepicker/datepicker'
import { parse,
  isSameDay,
  startOfMonth,
  format,
  isToday,
  isYesterday,
  endOfMonth,
  subDays,
  subMonths
} from 'date-fns';
import Switcher from '../ui/swticher/switcher'

export const StatDateTimeFilter = (
  {
    updateScheme,
    renderSelected,
    scheme
  }
) => {
  const [minDate, setMinDate] = useState('')
  const [maxDate, setMaxDate] = useState('')
  const [dateRangeView, setDateRangeView] = useState(false)
  const {dateFrom, dateTo} = scheme

  useEffect(() => {
    if(!dateRangeView) {
      const dateVal = dateFrom?.val
      if(dateVal) {
        updateScheme({
          key: 'dateTimePeriod',
          path: 'dateTo',
          type: 'date',
          label: 'По',
          val: dateVal
        })
        renderSelected()
      }
    }
  }, [dateRangeView])

  const parseDate = (str) => parse(str, 'dd.MM.yyyy', new Date());

  const parsedFrom = parseDate(dateFrom?.val);
  const parsedTo = parseDate(dateTo?.val);
  const now = new Date();

  // За сегодня
  const isTodayRange = isSameDay(parsedFrom, parsedTo) && isToday(parsedFrom);
  // За вчера
  const isYesterdayRange = isSameDay(parsedFrom, parsedTo) && isYesterday(parsedFrom);
  // За этот месяц
  const isCurrentMonthRange = isSameDay(parsedFrom, startOfMonth(now)) && isSameDay(parsedTo, now);
  // За прошлый месяц
  const lastMonth = subMonths(now, 1);
  const startOfLastMonth = startOfMonth(lastMonth);
  const endOfLastMonth = endOfMonth(lastMonth);
  const isLastMonthRange = isSameDay(parsedFrom, startOfLastMonth) &&
    isSameDay(parsedTo, endOfLastMonth);


  const setRange = (from, to) => {
    const formattedFrom = format(from, 'dd.MM.yyyy')
    const formattedTo = format(to, 'dd.MM.yyyy')
    updateScheme({
      key: 'dateTimePeriod',
      path: 'dateFrom',
      type: 'date',
      label: 'С',
      val: formattedFrom,
    })
    updateScheme({
      key: 'dateTimePeriod',
      path: 'dateTo',
      type: 'date',
      label: 'По',
      val: formattedTo,
    })
    renderSelected()
  }

  const setTodayRange = () => {
    setDateRangeView(false)
    const today = new Date()
    setRange(today, today)
  }

  const setYesterdayRange = () => {
    setDateRangeView(false)
    const yesterday = subDays(new Date(), 1)
    setRange(yesterday, yesterday)
  }

  const setCurrentMonthRange = () => {
    setTimeout(() => {setDateRangeView(true)})
    const now = new Date()
    setRange(startOfMonth(now), now)
  }

  const setLastMonthRange = () => {
    setDateRangeView(true)
    setTimeout(() => {
      const now = new Date()
      const lastMonth = subMonths(now, 1)
      setRange(startOfMonth(lastMonth), endOfMonth(lastMonth))
    })
  }

  const onChangeStartDate = ({ value }) => {
    const formatedDate = format(new Date(value), 'dd.MM.yyyy')
    setMinDate(new Date(value))
    updateScheme({
      key: 'dateTimePeriod',
      path: 'dateFrom',
      type: 'date',
      label: 'С',
      val: formatedDate
    })
    if(!dateRangeView) {
      onChangeEndDate({value})
    }
  }
  const onChangeEndDate = ({ value }) => {
    const formatedDate = format(new Date(value), 'dd.MM.yyyy')
    dateRangeView && setMaxDate(new Date(value))
    updateScheme({
      key: 'dateTimePeriod',
      path: 'dateTo',
      type: 'date',
      label: 'По',
      val: formatedDate
    })
  }

  const onSwitcherChange = () => {
    setDateRangeView(!dateRangeView)
  }

  return (
    <div className={`my-[1.2rem]`}>
      <div className={`flex gap-[1rem] mb-[1.2rem] items-center`}>
        <div className={`inline-flex my-[1.2rem] min-w-[12.5rem]`}>
          <Switcher
            className={`min-w-[12.5rem] flex justify-center`}
            label={dateRangeView ? 'Период' : 'Дата'}
            toggler
            active={dateRangeView}
            onChange={onSwitcherChange}
          />
        </div>
        <div
          onClick={setTodayRange}
          className={`text-Regular(16_18) hover:cursor-pointer ${isTodayRange ? 'text-Accent/Blue border-Accent/Blue' : 'border-Content/Border'}
          border px-[1rem] py-[1.3rem] flex gap-[0.8rem] hover:border-Accent/Blue ease-in-out duration-300`}>
          Сегодня
        </div>
        <div
          onClick={setYesterdayRange}
          className={`text-Regular(16_18) hover:cursor-pointer border 
           px-[1rem] py-[1.3rem] flex gap-[0.8rem] hover:border-Accent/Blue
            ease-in-out duration-300 ${isYesterdayRange ? 'text-Accent/Blue border-Accent/Blue' : 'border-Content/Border'}`}>
          Вчера
        </div>
        <div
          onClick={setCurrentMonthRange}
          className={`text-Regular(16_18) hover:cursor-pointer ${isCurrentMonthRange ? 'text-Accent/Blue border-Accent/Blue' : 'border-Content/Border'}
          border px-[1rem] py-[1.3rem] flex gap-[0.8rem] hover:border-Accent/Blue ease-in-out duration-300`}>
          Текущий месяц
        </div>
        <div
          onClick={setLastMonthRange}
          className={`text-Regular(16_18) hover:cursor-pointer hover:border-Accent/Blue ease-in-out duration-300 ${isLastMonthRange ? 'text-Accent/Blue border-Accent/Blue' : 'border-Content/Border'}
          border px-[1rem] py-[1.3rem] flex gap-[0.8rem]`}>
          Прошлый месяц
        </div>
      </div>
      <div className={`flex gap-[1.2rem] items-center justify-between`}>
        <div className={`flex-1`}>
          <Datepicker
            setInitialImmediate
            renderSelected={renderSelected}
            maxDate={maxDate ? new Date(maxDate) : new Date()}
            onChange={onChangeStartDate}
            labelSmall={true}
            syncDate={parsedFrom}
            label={dateRangeView ? 'C' : 'Дата'}></Datepicker>
        </div>
        {dateRangeView && (
          <div className={`flex-1`}>
            <Datepicker
              renderSelected={renderSelected}
              minDate={minDate ? new Date(minDate) : new Date()}
              maxDate={new Date()}
              setInitialImmediate
              onChange={onChangeEndDate}
              labelSmall={true}
              syncDate={parsedTo}
              label='По'></Datepicker>
          </div>
        )}
      </div>
    </div>
  )
}